<div class="container">
  <div class="flex align-items-center justify-content-end width-100 mb-3">
    <p-button
      icon="pi pi-filter"
      severity="primary"
      outlined
      rounded
      (onClick)="openDialogFilters()"
      label="Filtros avançados"
      iconPos="right"
    ></p-button>
  </div>
  <div class="grid dashboard">
    <div class="grid dashboard w-100">
      <card-statistics
        class="col-12 md:col-6 lg:col-3"
        *ngFor="let item of dashboardData"
        [dashboardItem]="item"
      >
      </card-statistics>
    </div>
  </div>
</div>
